import {Component, OnInit, OnDestroy, inject} from '@angular/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from '@app/material.module';
import {ItemRoomComponent} from '@components/rooms/item-room/item-room.component';
import {RoomsService} from '@services/api/rooms/rooms.service';
import {ApiResponse} from '@interfaces/response';
import {Room} from '@interfaces/room';

@Component({
  selector: 'app-rooms-list',
  imports: [TablerIconsModule, MaterialModule, ItemRoomComponent],
  standalone: true,
  templateUrl: './rooms-list.component.html',
  styleUrl: './rooms-list.component.scss'
})
export class RoomsListComponent implements OnInit, OnDestroy {

  private room_service: RoomsService = inject(RoomsService);
  public listRooms: Room[] = [];

  public connectlistRooms = [];
  private refreshIntervalId: any;

  ngOnInit() {
    this.getRooms();
    this.refreshIntervalId = setInterval(() => this.getRooms(), 15000);
  }

  ngOnDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  }

  private getRooms() {
    this.room_service.getRoomActivePromise().then((connect_list: any) => {
      this.connectlistRooms = connect_list;
      return this.room_service.getRoomsPromise();
    }).then((listRoom: ApiResponse<Room[]>) => {
      // this.listRooms = listRoom.data;
      this.listRooms = listRoom.data.map(itemRoom => {
        const connectedItem = this.connectlistRooms.find(item => item['connectionId'] === itemRoom.uuid);
        return {
          ...itemRoom,
          connected: !!connectedItem,
          connectionNumber: connectedItem ? connectedItem['connectionNumber'] : 0
        };
      });
    });
  }


}
